import { HOURS_PER_DAY } from '../../constants/time';
import type { Phase } from '../../types/domain';
import { contractTotalMonths } from '../dates';
import { toNumber } from '../numbers';
import { timeAndMaterialsCapacity } from './sold';

const round1 = (n: number) => Math.round(n * 10) / 10;

// Quota converti en jours sur tout le contrat : unités *_mois × mois, unités *_an × mois / 12.
function contractQuotaDays(qty: unknown, unit: string, months: number): number {
  const days = (toNumber(qty || 0) || 0) / (unit.startsWith('heures') ? HOURS_PER_DAY : 1);
  return unit.endsWith('_an') ? (days * months) / 12 : days * months;
}

/* Quota total d'une maintenance sur tout son contrat, en jours (mêmes unités par défaut que la
   carte : correctif en heures/mois, évolutif en jours/an). */
export function maintenanceTotalQuotaDays(phase: Phase): number {
  const months =
    contractTotalMonths(phase.dateDebut, phase.dateFin) || toNumber(phase.dureeMois || 0) || 0;
  return round1(
    contractQuotaDays(phase.correctifQte, phase.correctifUnite || 'heures_mois', months) +
      contractQuotaDays(phase.evolutifQte, phase.evolutifUnite || 'jours_an', months),
  );
}

/* Bilan d'une régie ou d'une maintenance clôturée (arbitrage du 07/10/2026) : « ce mois » n'a
   plus de sens, la carte montre le total saisi sur la phase face à sa capacité (régie) ou à son
   quota total (maintenance). */
export function closedPhaseTotal(phase: Phase, hoursSpent: number) {
  const days = round1(hoursSpent / HOURS_PER_DAY);
  const isRegie = phase.facturation === 'regie_temporelle' || phase.facturation === 'regie_horaire';
  const ref = isRegie ? timeAndMaterialsCapacity(phase) : maintenanceTotalQuotaDays(phase);
  return { days, ref, pct: ref > 0 ? Math.round((days / ref) * 100) : null };
}
